module.exports = __webpack_public_path__ + "static/media/journal-whills.912dd6ba.svg";